<template>
<div id="app">
  <v-app id="inspire">
    <v-navigation-drawer
      v-if="showflag"
      clipped
      fixed
      v-model="drawer"
      app
      color="#f6f6f6"
      
      >
        <v-list>
        <template v-for="menu in menulist">
          <template v-if="menu.sublist.length > 0">
            <v-list-group
              :key="menu.IDX"
              no-action
              color="#000000"
              >
              <template v-slot:activator>
                  <v-icon>{{menu.MENUICON}}</v-icon>
                  <v-list-item-content class="ml-2">
                    <v-list-item-title style="white-space: normal;"
                      :style="$i18n.locale == 'ko' ? 'font-size:18px' : 'font-size:13px'"
                      :key="menu.IDX" >{{ $i18n.locale == 'ko' ? menu.MENUNAME : menu.MENUNAME2 }}</v-list-item-title>
                  </v-list-item-content>
              </template>

              <v-list-item v-for="subitem in menu.sublist" :key="subitem.IDX"
                          class="pa-0" style="display:block"
                          :class="subitem.ROUTE === ROUTERNAME ? 'selectlist' : 'normallist'"
                          :style="$i18n.locale == 'ko' ? 'font-size:18px' : 'font-size:13px'"
                          @click="callrouteName(subitem.ROUTE, subitem.GRADE, $i18n.locale == 'ko' ? subitem.MENUNAME : subitem.MENUNAME2 )">
                
                <v-list-item-content class="ml-0" :style="subitem.MENUNAME == '후기 관리' ? 'border-bottom: 1px dashed rgba(0, 0, 0, 0.12);' : ''">
                  <v-list-item-title 
                    :class="subitem.ROUTE === ROUTERNAME ? 'selectlist' : 'normallist'" 
                    class="pl-11" 
                    :style="$i18n.locale == 'ko' ? 'font-size:18px !important;' : 'font-size:13px !important;'"
                    :key="subitem.IDX">{{ $i18n.locale == 'ko' ? subitem.MENUNAME : subitem.MENUNAME2 }}
                  </v-list-item-title>
                </v-list-item-content>

              </v-list-item>
              
                
            </v-list-group>
            
          </template>
          <template v-else>
            <v-list-item  :key="menu.IDX" 
                          :class="menu.ROUTE === ROUTERNAME ? 'selectlist' : 'normallist'"
                          :style="$i18n.locale == 'ko' ? 'font-size:18px' : 'font-size:13px'"
                          @click="callrouteName(menu.ROUTE, menu.GRADE, $i18n.locale == 'ko' ? menu.MENUNAME : menu.MENUNAME2 )">
              <v-icon color="#5c5f62" >{{menu.MENUICON}}</v-icon>
              <v-list-item-content class="ml-2" :class="menu.ROUTE === ROUTERNAME ? 'selectlist' : 'normallist'">
                <v-list-item-title :style="$i18n.locale == 'ko' ? 'font-size:18px' : 'font-size:13px'"
                  :key="menu.IDX">
                  {{ $i18n.locale == 'ko' ? menu.MENUNAME : menu.MENUNAME2 }}
                  <!-- 줄바꿈 -->
                  <!-- <div v-html="$i18n.locale == 'ko' ? menu.MENUNAME : menu.MENUNAME2"/> -->
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>

        </template>

      </v-list>

      <v-divider></v-divider>
      <v-list-item @click="logout()" v-if="login_flag">
        <v-list-item-action>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title style="font-size:13px;"> {{ $i18n.locale == 'ko' ? '로그아웃' : 'Logout' }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-navigation-drawer>

    <v-app-bar v-if="showflag" elevation="0" app fixed clipped-left dense style="background-color:#f6f6f6;color:#212121; border-style:solid; border-width:0px 0px 2px 0px;border-color:#e9e9e9">
      <v-app-bar-nav-icon style="color:#212121" @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <template v-if="this.$hostname == 'admin.mnccom-reg.com'">
        <v-avatar class="ml-5" :tile="true" width="130" height="24" @click="gohome">
          <img :src="require('@/assets/mnclogo.png')" alt="logo">
        </v-avatar>
      </template>
      <template v-else-if="this.$hostname == 'admin.pictcloud.com'">
        <v-avatar class="ml-5" :tile="true" width="64" height="24" @click="gohome">
          <img :src="require('@/assets/pictlogo.png')" alt="logo">
        </v-avatar>
      </template>
      <template v-else>
        <v-avatar class="ml-5" :tile="true" width="170" height="24" @click="gohome">
          <img  :src="require('@/assets/logo.png')" alt="logo">
        </v-avatar>
      </template>
      <!-- <v-toolbar-title>{{ COM_NAME }}</v-toolbar-title> -->
      <v-spacer/>

      <!-- 한/영 선택 -->
      <v-select 
        v-if="$uselan"   
        style="widht:100px;max-width:100px;font-size:12px;background:#f6f6f6"
        outlined dense hide-details color="#e9e9e9"
        v-model="$i18n.locale" :items="$lanlist" item-text="name" item-value="value"
        @change="changelan" 
        />
      

    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>
    <v-footer app height="auto" style="background-color:#f6f6f6;color:#2c2c2c">
      <v-spacer></v-spacer>
      <template v-if="this.$hostname == 'admin.mnccom-reg.com'">
        <span>&copy; 2024 MNC</span>
      </template>
      <template v-else-if="this.$hostname == 'admin.pictcloud.com'">
        <span>&copy; 2024 PICT</span>
      </template>
      <template v-else>
        <span>&copy; 2021 <a target="_blank" href="https://www.blueorigin.co.kr">BlueOrigin</a></span>
      </template>
      
      <v-spacer></v-spacer>
    </v-footer>
  </v-app>
</div>
</template>

<script>
//import { EventBus } from './util/event-bus'

//홈페이지 설정 스타일
import '@/assets/css/PageSet.css';

export default {

  data: () => ({
      drawer: false
    , menulist : []
    , login_flag : false
    , COM_NAME : ''
    , ROUTERNAME: ''
    , showflag: false //사이드 메뉴와 탑바의 보여주기 유무
  }),

  created(){

    //총판 로고 분기를 위한 호스트 네임 백업
    //this.$hostname = window.location.hostname;
    //console.log("app hostname1: " + this.$hostname);

    if(this.$hostname == "admin.mnccom-reg.com"){
      document.title = "M&C 관리자";  
    }else if(this.$hostname == "admin.pictcloud.com"){
      document.title = "PICT 관리자";  
    }else{
      document.title = "FAIRPASS 관리자";  
    }
    //document.title

    //로그인 전역 이벤트 수신
    this.$EventBus.$on('loginresult', this.selectmenu);

    //화면이동 이벤트 수신
    this.$EventBus.$on('movepageresult', this.movepage);

  },


  methods: {

    changelan(){
      localStorage.setItem("LOCALE", this.$i18n.locale);
      //팝업창 텍스트 영문화
      if(this.$i18n.locale == 'ko'){        
        this.$alert_option.confirmButtonText = "확인";
        this.$alert_option.cancelButtonText  = "취소";        
      }else{        
        this.$alert_option.confirmButtonText = "OK";
        this.$alert_option.cancelButtonText  = "Cancel";
      }

    },

    gohome(){
      this.$router.push("Welcome").then(()=>{
        this.ROUTERNAME = "Welcome";
      })
      .catch(()=>{
      });
    },

      logout:function(){

        if(this.login_flag){

          this.$confirm("로그아웃 하시겠습니까?")
          .then(() => {
            this.$session.clear("ADMIN_IDX");
            this.$session.clear("COM_IDX");
            this.$session.clear("ACNT_IDX");
            this.$session.clear("GRADE");
            this.$session.clear("COM_NAME");
            this.$session.clear("LOGIN_NAME");
            this.$session.clear("ACCESSTOKEN");
            this.$session.clear("REFLASHTOKEN");
            this.selectmenu();
          });

        }

      },


      //로그인 전역 이벤트 수신
      selectmenu:function(){
        if(this.$session.exists("ACNT_IDX")){
          this.showflag = true;
          this.drawer = true;
          this.login_flag = true;
          this.getmenulist();
          this.COM_NAME = this.$session.get("LOGIN_NAME");
        }else{
          this.showflag = false;
          this.drawer = false;
          this.login_flag = false;
          this.removemenulist();
          this.$router.push('Login');   //로그인 페이지로 이동
          this.COM_NAME = "";
        }
      },

      //화면이동 전역 이벤트 수신
      movepage(router_name, menuname){
        //console.log("movepage : " + router_name + " / " + menuname);
        this.$router.push(router_name).then(()=>{
          this.ROUTERNAME = router_name;
          this.$session.set("MENUNAME",   menuname);
          this.$forceUpdate();
        })
        .catch(()=>{
        });  //해당 이름으로 라우트됨 ex) link면 /link 로 라우트
      },

      callrouteName:function(router_name, grade, menuname){

        //console.log("callroutename : " + router_name + " / " +menuname );

          //권한등급 체크
          if(this.$session.get("GRADE") >= grade){
            this.$session.set("MENUNAME",   menuname);
            this.$router.push(router_name).then(()=>{
              this.ROUTERNAME = router_name;
            })
            .catch(()=>{
            });  //해당 이름으로 라우트됨 ex) link면 /link 로 라우트
            
          }else{
            this.$alert("사용할 수 없는 권한의 페이지입니다.");
          }

      },

      getmenulist:function(){

        this.$http.post(this.$host+'/api/getMenuList'
        ,{
        },{headers: { accesstoken:this.$session.get("ACCESSTOKEN"), reflashtoken:this.$session.get("REFLASHTOKEN")}})
        .then((result)=>{

          if(result.data.resultCode == 0){

            //토큰 저장
            if(result.data.accesstoken != null && result.data.accesstoken.length > 0){
              this.$session.set("ACCESSTOKEN",   result.data.accesstoken);
            }
            if(result.data.reflashtoken != null && result.data.reflashtoken.length > 0){
              this.$session.set("REFLASHTOKEN",   result.data.reflashtoken);
            }

            var glist = result.data.groupData;
            var slist = result.data.subData;

            glist.forEach(group => {

                group.sublist = [];
                slist.forEach(sub=>{
                  if(group.MENUNAME == sub.GROUPNAME){
                    group.sublist.push(sub);
                  }
                });

                /*
                if(group.sublist.length == 0){
                  group.sublist.push({IDX:group.IDX, COM_IDX:group.COM_IDX, MENUNAME:group.MENUNAME, ROUTE:group.ROUTE});
                }
                */

            });
            this.menulist.splice(0, this.menulist.length);
            glist.forEach(element => {
              this.menulist.push(element); 
            });

          }else if(result.data.resultCode == 2){

            //로그인 필요
            this.$alert(this.$t("common_tokener")).then(()=>{
              this.$session.clear("ADMIN_IDX");
              this.$session.clear("COM_IDX");
              this.$session.clear("ACNT_IDX");
              this.$session.clear("GRADE");
              this.$session.clear("COM_NAME");
              this.$session.clear("ACCESSTOKEN");
              this.$session.clear("REFLASHTOKEN");
              this.login_flag = false;
              this.removemenulist();
              this.$router.push('Login');   //로그인 페이지로 이동
            });

          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch((error)=>{
            if(error.message == 'Request failed with status code 429')
            {
              this.$alert(this.$t("common_reqer"));
            }else{
              this.$alert(error.message);
            }
        });

      },

      removemenulist:function(){
        //모두 제거
        this.menulist.splice(0, this.menulist.length);
      },

      //페이지 새로고침 또는 주소창에 다른주소 입력해서 빠져나갈 때 경고
      unloadevent:function(event){
        event.preventDefault();
        event.returnValue = "";
      }


  },


  beforeDestroy(){
    
    //로그인 전역 이벤트 수신 해제
    this.$EventBus.$off('loginresult');

    //페이지 이동 이벤트 수신 해제
    this.$EventBus.$off('movepageresult');
    
  },

  beforeUnmount() {
    //console.log("beforeMount...");
    window.removeEventListener('beforeunload', this.unloadevent);
  },

  mounted(){
    //console.log("mount...");
    window.addEventListener('beforeunload', this.unloadevent);

    if(this.$hostname == "admin.mnccom-reg.com"){
      document.title = "M&C 관리자";  
    }else if(this.$hostname == "admin.pictcloud.com"){
      document.title = "PICT 관리자";  
    }else{
      document.title = "FAIRPASS 관리자";  
    }

    if(this.$session.exists("ACNT_IDX")){
      //로그인이 된 경우 (새로고침 케이스)
      this.showflag = true;
      this.selectmenu();
    }else{

      //로그인이 안된 경우 무조건 로그인으로 넘기지 말 것.

      //로그인이 안된 상태면
      //this.$router.push('Login');   //로그인 페이지로 이동

    }

    const lc = localStorage.getItem("LOCALE");
    if(lc != null){
      this.$i18n.locale = lc;
    }else{
      this.$i18n.locale = 'ko';
    }
    //팝업창 텍스트 영문화
    if(this.$i18n.locale == 'ko'){        
      this.$alert_option.confirmButtonText = "확인";
      this.$alert_option.cancelButtonText  = "취소";        
    }else{        
      this.$alert_option.confirmButtonText = "OK";
      this.$alert_option.cancelButtonText  = "Cancel";
    }

  }

}
</script>

<style>
  /* 여기는 기본 태그들에 스타일을 먹이는 곳인듯 */
  
  /* 전역 컬럼헤더 기본 스타일 */
  table thead tr th span {
    font-size: 16px;
    color:black;
  }

  .header_text_style{
    font-size: 16px !important;
    color:black !important;
  }

  /* 전역 컬럼바디 기본 스타일 */
  table tbody tr td {
    font-size: 16px !important;
    color:black !important;
  }

  /* 전역 데이터 테이블 라운드 스타일 */
  .datatablestyle{
    border-radius: 10px; 
    border-color:#ebebeb; 
    border-style:solid; 
    border-width:1px 2px 3px 2px
  }

  .menunamestyle{
    font-size:19px;
    color: #000000;
  }
  
  .total_label{
    font-size: 16px; color: rgb(65, 105, 214);
  }

  /* 다이얼로그 스크롤 스타일 변경 */
  .v-dialog::-webkit-scrollbar {
    width: 0px;
  }

  /* 다이얼로그 파란색 라운드 처리 
  .v-dialog{
    background-color: white;
    border-radius: 20px; 
    border-color:#4e6ef7; 
    border-style:solid; 
    border-width:2px 2px 2px 2px;
  }
  */

  .v-dialog{
    background-color: transparent;
    box-shadow: none !important;
  }

  /* 다이얼로그 내부 v-ard 스크롤 스타일 변경 */
  .v-card__text::-webkit-scrollbar {
    width: 10px;
  }
  .v-card__text::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #ebebeb;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 8px;
    background-color: #999999;
  }

  /* 하단 페이징 번호 폰트 스타일 */
  .d-flex.justify-center span{
    font-size: 16px !important;
  }

  /* 다이얼로그 하단 버튼 */
  .dialog_btn {
    color: #ffffff !important;
    background-color: #4e6ef7 !important;
    font-size: 16px !important;
    width: 94px !important; 
    height: 30px !important;
  }

  /* 다이얼로그 하단 버튼 */
  .dialog_cancel_btn {
    color: #000000 !important;
    background-color: #e5e5e5 !important;
    font-size: 16px !important;
    width: 94px !important; 
    height: 30px !important;
  }

  /* 다이얼로그 클로즈 버튼 */
  .dialog_close_btn {
    color: #e5e5e5 !important;
    background-color: #ffffff !important;
    border-color:#e5e5e5 !important; 
    border-style:solid !important; 
    border-width:3px 3px 3px 3px !important;
  }

  /* 다이얼로그 타이틀 */
  .dialog_title {
    color: #4e6ef7 !important;
    font-size: 20px !important;
    font-weight: bold !important;
  }

  /* 다이얼로그 라운드 처리 */
  .dialog_round{
    background-color: white !important;
    border-radius: 20px !important; 
    border-color:#4e6ef7 !important; 
    border-style:solid !important; 
    border-width:2px 2px 2px 2px !important;
  }

  /* 검색창 기본 버튼 스타일 */
  .search_btn {
    color: #2f2f2f !important;
    background-color: #e5e5e5 !important;
    border: thin solid #d1d1d1 !important;
    font-size: 16px !important;
    width: 94px !important; 
    height: 43px !important;
  }
  .search_btn_freesize {
    color: #2f2f2f !important;
    background-color: #e5e5e5 !important;
    border: thin solid #d1d1d1 !important;
    font-size: 16px !important;
    height: 43px !important;
    text-transform: none !important;
    font-weight: bold !important;
  }
  .search_btn[data-my-variable="false"]{
    color: #2f2f2f !important;
    background-color: #e5e5e5 !important;
    border: thin solid #d1d1d1 !important;
    font-size: 12px !important;
    width: 94px !important; 
    height: 43px !important;
  }
  .search_btn_freesize[data-my-variable="false"]{
    color: #2f2f2f !important;
    background-color: #e5e5e5 !important;
    border: thin solid #d1d1d1 !important;
    font-size: 12px !important;
    height: 43px !important;
    text-transform: none !important;
    font-weight: bold !important;
  }




  /* 검색창 노란색 버튼 스타일 */
  .yellow_btn {
    color: #2f2f2f !important;
    background-color: #ffd797 !important;
    border: thin solid #ffcb72 !important;
    font-size: 16px !important;
    width: 94px !important; 
    height: 43px !important;
    text-transform: none !important;
  }
  .yellow_btn[data-my-variable="false"]{
    color: #2f2f2f !important;
    background-color: #ffd797 !important;
    border: thin solid #ffcb72 !important;
    font-size: 12px !important;
    width: 94px !important; 
    height: 43px !important;
    text-transform: none !important;
  }
  .yellow_btn_freesize {
    color: #2f2f2f !important;
    background-color: #ffd797 !important;
    border: thin solid #ffcb72 !important;
    font-size: 16px !important;
    height: 43px !important;
    text-transform: none !important;
  }
  .yellow_btn_freesize[data-my-variable="false"]{
    color: #2f2f2f !important;
    background-color: #ffd797 !important;
    border: thin solid #ffcb72 !important;
    font-size: 12px !important;
    height: 43px !important;
    text-transform: none !important;
    white-space: pre-line !important;
  }

  /* 검색창 파랑색 버튼 스타일 */
  .blue_btn {
    color: #2f2f2f !important;
    background-color: #e0eeff !important;
    border: thin solid #c4d0f8 !important;
    font-size: 16px !important;
    width: 94px !important; 
    height: 43px !important;
    text-transform: none !important;
  }
  /* 변수 값에 따라서 스타일 다르게 처리 */
  .blue_btn[data-my-variable="false"]{
    color: #2f2f2f !important;
    background-color: #e0eeff !important;
    border: thin solid #c4d0f8 !important;
    font-size: 12px !important;
    width: 94px !important; 
    height: 43px !important;
    text-transform: none !important;
  }

  .blue_btn_freesize{
    color: #2f2f2f !important;
    background-color: #e0eeff !important;
    border: thin solid #c4d0f8 !important;
    font-size: 16px !important;
    height: 43px !important;
    text-transform: none !important;
    white-space: normal !important;
  }
  .blue_btn_freesize[data-my-variable="false"]{
    color: #2f2f2f !important;
    background-color: #e0eeff !important;
    border: thin solid #c4d0f8 !important;
    font-size: 12px !important;
    height: 43px !important;
    text-transform: none !important;
    white-space: pre-line !important;
  }

  .fairpass_btn_freesize{
    color: #ffffff !important;
    background-color: #4e6ef7 !important;
    border: thin solid #4e6ef7 !important;
    font-size: 16px !important;
    height: 43px !important;
  }

  /* 다이얼로그 하단 버튼 */
  .dialog_color_btn {
    color: #ffffff !important;
    background-color: #4e6ef7 !important;
    font-size: 16px !important;
    height: 43px !important;
  }

  /* 데이터 테이블 정렬용 컬럼 헤더 스타일 */
  .cheader_sortselect{
    font-size: 16px !important;
    color:red !important;
  }
  
  .cheader_sort{
    font-size: 16px !important;
    color:#4e6ef7 !important;
  }

  .cheader_normal{
    font-size: 16px !important;
    color:#000000 !important;
  }

  /* 명찰디자인 앞면 라벨 디자인 */
  .front_info_label{
    color: white !important;
    background-color: #4e6ef7 !important;
    width: 96px !important;
    height: 46px !important;
    border-radius: 23px !important; 
    text-align: center;
    padding-top: 10px;
  }
  /* 명찰디자인 뒷면 라벨 디자인 */
  .back_info_label{
    color: #656565 !important;
    background-color: #d1d1d1 !important;
    width: 96px !important;
    height: 46px !important;
    border-radius: 23px !important; 
    text-align: center;
    padding-top: 10px;
  }
  /* 명찰디자인 블루 라운드에 흰색 배경 버튼 */
  .white_blue_btn{
    color: #4e6ef7 !important;
    background-color: #ffffff !important;
    font-size: 16px !important;
    width: 94px !important; 
    height: 43px !important;
    border-width:2px 2px 2px 2px !important;
    border-color:#a6b6fb !important; 
    border-radius: 7px !important; 
  }
  .white_blue_fullbtn{
    color: #4e6ef7 !important;
    background-color: #ffffff !important;
    font-size: 16px !important;
    height: 43px !important;
    border-width:2px 2px 2px 2px !important;
    border-color:#a6b6fb !important; 
    border-radius: 7px !important; 
  }


  /* 대쉬보드 퀵버튼 라운드 배경 처리 */
  .quick_btn_round{
    background: #ffffff !important;
    border-radius: 5px !important; 
    max-width: 290px;
    width:290px;
    min-width:190px;
    height: 63px !important;
    margin-left: 5px;
    margin-right: 5px;
    margin-top: 10px;
    cursor: pointer;
  }
  .quick_btn_round:hover{
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.3);
  }

  /* 대쉬보드 퀵버튼 텍스트 처리 */
  .quick_btn_text{
    display:block;
    font-size:18px !important;
    font-weight: normal;
    color: #656565;
    text-transform: none !important;
  }

  .quick_btn_text2{
    display:block;
    font-size:13px !important;
    font-weight: normal;
    color: #656565;
    text-transform: none !important;
    white-space: normal;
  }

  /* 대쉬보드 영역 라운드 */
  .quick_area_round{
    background-color: #ffffff !important;
    border-radius: 10px !important; 
    border-color:#c2c2c2 !important; 
    border-style:solid !important; 
    border-width:0px 0px 0px 0px !important;
  }
  /* 대쉬보드 타이틀 */
  .dash_bluetext{
    text-align: left;
    font-size: 16px !important;
    color: #000000 !important;
    font-weight: bold !important;
    text-decoration: none !important;
  }
  /* 대쉬보드 이미지 아이콘 라운드  */
  .dash_imground{
    border-radius: 40px !important; 
    width: 115px !important; 
    height: 115px !important; 
    text-align: center !important; 
    vertical-align: middle !important; 
    justify-content: center;
    display: flex;
    flex-direction: column;
    box-shadow: 0px 2px 1px #dedede;
  }
  /* 대쉬보드 명수 텍스트  */
  .dash_cnttext{
    margin-top: 5px;
    font-style: normal;
    font-size: calc(0.75rem + 0.5vw);
    line-height: 30px;
    align-items: center;
    color: #808080;
    text-align:left;
  }

  /* 대쉬보드 메인 라운드 */
  .dashboard_round{
    padding: 20px !important;
    background-color: #F8F8F8 !important;
    border-radius: 10px !important; 
    margin: 0px 5px 0px 5px;
  }
  .dashboard_round_small{
    background-color: #F8F8F8 !important;
    border-radius: 10px !important; 
    margin: 0px 5px 0px 5px;
    height:50px; 
    padding: 0px 10px 0px 20px !important
  }

  /* 대쉬보드 기타 텍스트  */
  .dash_text{
    color:#808080;
    font-style: normal;
    font-size: 15px;
    line-height: 16px;
    text-align: left;
    margin-top: 15px;
  }
  .dash_cnt{
    color:#808080;
    font-family: 'Noto Sans KR';
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
  }

  /* 대쉬보드 테이블 스타일 */
  .dashtablestyle{
    border-radius: 10px; 
    border-color:#f1f1f1; 
    border-style:solid; 
    border-width:1px 2px 3px 2px
  }

  .dashtablebg tr{
    background-color: #f1f1f1 !important;
  }

  .chartsum_round{
    background-color: #fafafa !important;
    border-color:#f0f0f0 !important; 
    border-style:solid !important; 
    border-width:2px 2px 2px 2px !important;
  }
  .chartsum_title{
    display: block;
    font-size: 15px;
    margin-left: 10px;
    margin-top:5px;
  }
  .chartsum_value{
    display: block;
    font-size: 25px;
    font-weight: bold;
    margin-left: 10px;
    margin-bottom: 5px;
    max-lines: 1;
    white-space: nowrap;
  }

  .welcome_round{
    background-color: #ffffff !important;
    box-shadow: 0px 2px 1px #dedede;
  }
  .welcome_value{
    color:#000000;
    margin-top: 5px;
    font-size: calc(0.7rem + 1.8vw);
    line-height: 44px;
    font-weight: bold;
    white-space: nowrap;
    text-align: left;
  }

  .print_text_value{
    color:#000000;
    font-size: 30px;
    line-height: 30px;
    font-weight: bold;
    white-space: nowrap;
    text-align: left;
    padding-right:10px;
  }

  .total_amount_text{
    color:#627BFF;
    font-size: 20px;
    line-height: 20px;
    font-weight: bold;
    white-space: nowrap;
    text-align: left;
    padding-right:10px;
  }

  /* datetime 달력이 주수에 따라서 크기가 바뀌는게 싫다는 요청으로 고정함. */
  .vdatetime-popup{
    height:550px !important;
  }

  .select_input_bg{
    width: 100%;
    background: white;
    height: 32px;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    padding-left: 15px;
  }
  .select_blue_btn{
    width: 55px !important;
    height: 32px !important;
    background: #627BFF !important;
    font-family: 'Noto Sans KR' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 15px !important;
    line-height: 32px;
    color: #FFFFFF !important;
    cursor: pointer !important;
    text-align: center;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
  }

</style>

<style scoped>



  #logouttitle{
    font-size: 18px;
  }

  .normallist{
    font-size: 18px !important;
    color: #000000;
    background-color: #f6f6f6;
    white-space: normal;
  }

  .selectlist{
    font-size: 18px;
    color: #0061ff;
    background-color: #edeeef;
    white-space: normal;
  }

  a {
    color:#2c2c2c !important;
    text-decoration: none;
  }

</style>

<!-- 전체 폰트 -->
<style lang="scss">

  //로컬폰트 로드
  @font-face {
    font-family: 'AppleSDGothicNeoM';
    src: local('AppleSDGothicNeoM'), url("./assets/fonts/AppleSDGothicNeoM.ttf") format("truetype");
  }
  @font-face {
    font-family: 'Binggrae';
    src: local('Binggrae'), url("./assets/fonts/Binggrae.ttf") format("truetype");
  }
  @font-face {
    font-family: 'NotoSansKR-Bold';
    src: local('NotoSansKR-Bold'), url("./assets/fonts/NotoSansKR-Bold.otf");
  }
  @font-face {
    font-family: 'NotoSansKR-Regular';
    src: local('NotoSansKR-Regular'), url("./assets/fonts/NotoSansKR-Regular.otf");
  }

  //구글폰트
  //@import url('https://fonts.googleapis.com/css2?family=Nanum+Brush+Script&display=swap');
  //$font-family: 'Nanum Brush Script', cursive;

  //@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+KR:wght@100;300;900&display=swap');
  //$font-family: 'Nanum Brush Script', cursive;

  //전체 폰트 반영
  $font-family: 'NotoSansKR-Regular';
  .v-application {
    .headline,
    [class*='display-'],
    [class*='text-'] {
      color: #36405a;
      font-family: $font-family, sans-serif !important;
    }
    font-family: $font-family, sans-serif !important;
  }




</style>

